module.exports = __webpack_public_path__ + "img/news.94eb6e6d.png";